import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { useQuery} from '@apollo/client';
import gql from "graphql-tag"
import SearchListItems from "../SearchResult/SearchListItems"
import SearchNewHomesListItems from "../SearchResult/SearchNewHomesListItems"

const NoResultProperties = (status, department) => {

    const NoResultProperties = gql`
    query NoResultProperties($status: String!, $department: String!){
        properties(limit:6, where:{status:$status, department:$department, publish:true}) {
            id
            bathroom
            bedroom
            reception
            building
            crm_id
            display_address
            search_type
            status
            slug
            title
            department
            price
            price_qualifier
            images
            description
            imagetransforms
            office_crm_id
        }
    }`

    const NoResultNewHomesProperties = gql`
    query NoResultProperties{
        offplans(limit:6, where:{status:"Sale", publish:true}) {
            id
            display_address
            status
            bedroom
            description
            developer
            latitude
            longitude
            price
            status
            images
            max_price
            imagetransforms
            url
        }

    }`

    let qlQuery = NoResultProperties;
    let qlParmas = {status: status, department: department}

    if (department === 'newhomes') {
        qlQuery = NoResultNewHomesProperties;
        qlParmas = {publish: 'true'}
    }

    return useQuery(qlQuery, {
        variables: qlParmas
    });
}

const NoResultList = (props) => {

  const[department, setDepartment] = useState(props?.department || 'residential');

  useEffect(()=>{
    props.department && setDepartment(props.department);
  },[props.department]);

  const {loading:loading, error:error, data:data} = NoResultProperties(props.status, department);

  if (loading) return null;

  return (
    <React.Fragment>            
        {props?.department === "newhomes" ?
        <SearchNewHomesListItems map={props?.map} nostats={true} hits={data?.offplans} source={`strapi`} department={department}/>
        : 
        props.auctions ?
        <h5>Our next Auction Catalogue is out soon.</h5>
        // props.auctions? ""
        // <h5>Our next Auction Catalogue is out soon.</h5>
     :<SearchListItems  map={props?.map} nostats={true} hits={data?.properties} source={`strapi`} department={department}/>
        
    } 
    </React.Fragment>
  );
};

export default NoResultList;
